import { isElectron, electronOpenUniqueTab } from './electron';
import { isProd } from '@/constants/constants';
import { pinyin } from 'pinyin-pro';
import { QRCodeGenerator } from './qrcodeGenerator';
import XEUtils from 'xe-utils';
let util: any = {};

/**
 * @description 更新标题
 * @param {String} titleText 标题
 */
util.title = (titleText: string) => {
	window.document.title = titleText;
};

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = (url: string) => {
	if (url === '/') {
		url = document.location.origin;
	}

	const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;
	if (!reg.test(url)) {
		url = document.location.protocol + '//' + url;
	}

	let a = document.createElement('a');
	a.setAttribute('href', url);
	a.setAttribute('target', '_blank');
	a.setAttribute('id', 'app-link-temp');
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(document.getElementById('app-link-temp'));
};

/**
 * 生成随机len位数字
 * @param len
 * @param date
 * @returns {string}
 */
util.randomLenNum = (len: number, date: boolean = false) => {
	let random;
	random = Math.ceil(Math.random() * 100000000000000)
		.toString()
		.substr(0, len || 4);
	return date ? random + Date.now() : random;
};

/**
 * MD5加密
 * @param str
 * @returns {*}
 */
util.md5 = (str: string) => {
	let crypto = require('crypto');
	let md5 = crypto.createHash('md5');

	md5.update(str);
	return md5.digest('hex');
};

/**
 * 删除数据中指定的列表
 * @param data
 * @param id
 * @param key
 */
util.deleteDataList = (data: Array<any>, id: any, key: any) => {
	for (let i = data.length - 1; i >= 0; i--) {
		if (id.indexOf(data[i][key]) !== -1) {
			data.splice(i, 1);
		}
	}
};

/**
 * 将任意对象转化为树
 * @param data
 * @param key
 * @param pid
 * @param parent
 * @returns {Array}
 */
util.formatDataToTree = (data: Array<any>, key: string = 'id', pid: string = 'parentId', parent: any = {}) => {
	if (!data || Object.keys(data).length <= 0) {
		return [];
	}

	let map: any = {};
	const isSetParent = Object.keys(parent).length > 0;

	data.forEach((value) => {
		if (isSetParent && parent.value.includes(value[parent.key])) {
			value[pid] = '0';
		}

		map[value[key]] = { ...value };
	});

	let tree = [];
	for (let id in data) {
		if (!Object.prototype.hasOwnProperty.call(data, id)) {
			continue;
		}

		// 对应索引
		const index = data[id][key];
		if (!Object.prototype.hasOwnProperty.call(map, index)) {
			continue;
		}

		// 子节点压入
		if (map[index][pid] && map[index][pid] != '0' && map[map[index][pid]]) {
			if (map[map[index][pid]] == '0') {
				continue;
			}

			if (!Object.prototype.hasOwnProperty.call(map[map[index][pid]], 'children')) {
				map[map[index][pid]].children = [];
			}

			map[map[index][pid]].children.push(map[index]);
			continue;
		}

		tree.push(map[index]);
	}

	return tree;
};

util.findFirstFromTree = (treeData: any, predicate: (obj: any) => true) => {
	if (!treeData) return;
	if (treeData instanceof Array) {
		if (treeData.length === 0) return;
		for (let i = 0; i < treeData.length; i++) {
			let item = treeData[i];
			if (predicate(item)) return item;
			if (item.children) {
				let ret = util.findFirstFromTree(item.children, predicate);
				if (ret) return ret;
			}
		}
	} else {
		if (predicate(treeData)) return treeData;
		if (!treeData.children) return;
		return util.findFirstFromTree(treeData.children, predicate);
	}
};

util.findFirstChildFromTree = (treeData: any) => {
	if (!treeData) return;
	if (treeData instanceof Array) {
		if (treeData.length === 0) return;
		for (let i = 0; i < treeData.length; i++) {
			let child = util.findFirstChildFromTree(treeData[i]);
			if (child) return child;
		}
	} else {
		if (!treeData.children) return treeData;
		return util.findFirstChildFromTree(treeData.children);
	}
};

util.findFirstChildFromTree = (treeData: any) => {
	if (!treeData) return;
	if (treeData instanceof Array) {
		if (treeData.length === 0) return;
		for (let i = 0; i < treeData.length; i++) {
			let child = util.findFirstChildFromTree(treeData[i]);
			if (child) return child;
		}
	} else {
		if (!treeData.children) return treeData;
		return util.findFirstChildFromTree(treeData.children);
	}
};

util.findFirstChildFromTree = (treeData: any) => {
	if (!treeData) return;
	if (treeData instanceof Array) {
		if (treeData.length === 0) return;
		for (let i = 0; i < treeData.length; i++) {
			let child = util.findFirstChildFromTree(treeData[i]);
			if (child) return child;
		}
	} else {
		if (!treeData.children) return treeData;
		return util.findFirstChildFromTree(treeData.children);
	}
};

/**
 * 替换对象中指定的替换值
 * @param data
 * @param replace
 * @returns {*}
 */
util.dataReplace = (data: any, replace: any) => {
	for (let value of data) {
		for (let key in value) {
			if (!Object.prototype.hasOwnProperty.call(value, key)) {
				continue;
			}

			if (Object.prototype.hasOwnProperty.call(replace, key)) {
				value[key] = replace[key][value[key]];
			}
		}
	}

	return data;
};

/**
 * 字符计量大小转换为字节大小
 * @param value
 * @returns {number}
 */
util.stringToByte = (value: string) => {
	const exp = '(^[0-9\\.]+)(\\w+)';
	const result = value.match(exp);

	if (!result) {
		return 0;
	}

	const size: number = Number(result[1]);
	const suffix: any = result[2].toLocaleUpperCase();

	const a: any = { B: 0, KB: 1, MB: 2, GB: 3, TB: 4, PB: 5 };
	const b: any = { B: 0, K: 1, M: 2, G: 3, T: 4, P: 5 };

	const pos = Object.prototype.hasOwnProperty.call(a, suffix) && a[suffix] !== 0 ? a[suffix] : b[suffix];
	return Math.round(size * Math.pow(1024, pos));
};

/**
 * 生成 GUID
 * @returns {string}
 */
util.guid = () => {
	let s: any = [];
	const hexDigits = '0123456789abcdef';

	for (let i = 0; i < 36; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
	}

	s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
	s[8] = s[13] = s[18] = s[23] = '-';

	return s.join('');
};

/**
 * 数字 格式化
 * @param num
 * @param digits
 * @returns {string}
 */
util.numberFormatter = (num: number, digits: number = 2) => {
	const si = [
		{ value: 1e18, symbol: 'EB' },
		{ value: 1e15, symbol: 'PB' },
		{ value: 1e12, symbol: 'TB' },
		{ value: 1e9, symbol: 'GB' },
		{ value: 1e6, symbol: 'MB' },
		{ value: 1e3, symbol: 'KB' },
	];

	for (let i = 0; i < si.length; i++) {
		if (num >= si[i].value) {
			return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
		}
	}

	return num.toString();
};

/**
 * 字节转字符串单位
 * @param bytes
 * @param spacer
 * @returns {string}
 */
util.bytesFormatter = (bytes: any, spacer: string = ' ') => {
	if (isNaN(bytes)) {
		return '';
	}

	const symbols = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	let exp = Math.floor(Math.log(bytes) / Math.log(2));

	if (exp < 1) {
		exp = 0;
	}

	const i = Math.floor(exp / 10);
	bytes = bytes / Math.pow(2, 10 * i);

	if (bytes.toString().length > bytes.toFixed(2).toString().length) {
		bytes = bytes.toFixed(2);
	}

	// bytes + symbols[i]
	return `${bytes}${spacer}${symbols[i]}`;
};

util.download = (url: string, filename: string) => {
	if (!filename) {
		var index = url.lastIndexOf('/');
		if (index !== -1) filename = url.substring(index + 1);
	}
	if (!filename) return;
	getBlob(url, (blob: any) => {
		saveAs(blob, filename);
	});
};

function getBlob(url: string, cb: (blob: any) => void) {
	var xhr = new XMLHttpRequest();
	xhr.open('GET', url, true);
	xhr.responseType = 'blob';
	xhr.onload = function () {
		if (xhr.status === 200) {
			cb(xhr.response);
		}
	};
	xhr.send();
}

function saveAs(blob: any, filename: string) {
	var link = document.createElement('a');
	var body: any = document.querySelector('body');

	link.href = window.URL.createObjectURL(blob);
	link.download = filename;

	// fix Firefox
	link.style.display = 'none';
	body.appendChild(link);

	link.click();
	body.removeChild(link);
	window.URL.revokeObjectURL(link.href);
}

/**
 * 将数值保留2位小数返回(不会四舍五入)
 * @param value
 * @returns {string}
 */
util.getNumber = (value: any) => {
	const toFixedNum = Number(value).toFixed(3);
	return value ? toFixedNum.substring(0, toFixedNum.toString().length - 1) : '0.00';
};

/**
 * 笛卡尔积算法
 * @param array
 * @returns {*|*[]|U}
 */
util.descartes = (array: Array<any>) => {
	if (array.length < 2) {
		return array[0] || [];
	}

	return [].reduce.call(array, (col: any, set: any) => {
		let res: any = [];
		col.forEach((c: any) => {
			set.forEach((s: any) => {
				let t: any = [].concat(Array.isArray(c) ? c : [c]);
				t.push(s);
				res.push(t);
			});
		});

		return res;
	});
};

/**
 * 验证URL地址
 * @param url
 * @returns {string|*}
 */
util.checkUrl = (url: string) => {
	if (url) {
		const blob = /^(blob)[^\s]+/;
		const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;

		if (!blob.test(url) && !reg.test(url)) {
			return document.location.protocol + '//' + url;
		}
	}

	return url;
};

/**
 * 版本号比较
 * @param curV
 * @param reqV
 * @returns {boolean}
 */
util.compareVersion = (curV: string, reqV: string) => {
	if (!curV || !reqV) {
		return false;
	}

	const arr1 = curV.split('.');
	const arr2 = reqV.split('.');
	const minLength = Math.min(arr1.length, arr2.length);

	let position = 0;
	let diff = 0;

	while (position < minLength && (diff = parseInt(arr1[position]) - parseInt(arr2[position])) === 0) {
		position++;
	}

	diff = diff !== 0 ? diff : arr1.length - arr2.length;
	return diff > 0;
};

/**
 * 日期格式化
 */
util.parseTime = (time: any, pattern: string) => {
	if (!time) {
		return null;
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}';
	let date;
	if (typeof time === 'object') {
		date = time;
	} else {
		if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
			time = parseInt(time);
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/');
		}
		if (typeof time === 'number' && time.toString().length === 10) {
			time = time * 1000;
		}
		date = new Date(time);
	}
	const formatObj: any = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay(),
	};
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key];
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value];
		}
		if (result.length > 0 && value < 10) {
			value = '0' + value;
		}
		return value || 0;
	});
	return time_str;
};

/**
 * uuid
 */
util.getUuid = () => {
	const len = 32; // 32长度
	let radix = 16; // 16进制
	const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	let uuid = [];
	let i = null;
	radix = radix || chars.length;
	if (len) {
		for (i = 0; i < len; i++) {
			uuid[i] = chars[0 | (Math.random() * radix)];
		}
	} else {
		let r;
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | (Math.random() * 16);
				uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
			}
		}
	}
	return uuid.join('');
};

util.formatToThousandSeparator = (num: number) => {
	return new Intl.NumberFormat().format(num);
};

util.openUniqueTab = (url: string, tabName?: string) => {
	if (!tabName) {
		const paths = url.match(/\/([^.]+)/);
		tabName = paths ? paths[1] : '_blank';
	}
	if (isElectron()) {
		return electronOpenUniqueTab(url, tabName);
	}
	// 检查是否已经打开过该标签页
	let existingTab: any = window.open('', tabName);
	if (existingTab.location.href === 'about:blank' || existingTab.closed) {
		// 如果标签页没有打开，则打开一个新标签页
		existingTab = window.open(url, tabName);
	} else {
		existingTab.location.href = url;
		// 如果已经打开，刷新该页面
		existingTab.location.reload();
		existingTab.focus();
	}
};

/**
 * 打开财务tab使用
 * @returns
 */
util.openUniqueFinancialTab = () => {
	// 根据当前链接判断是否是生产环境
	const isProduction = isProd.production.includes(window.location.hostname);
	// 获取当前页面的完整域名
	const hostname = window.location.hostname;
	// 按 "." 分割域名
	const parts = hostname.split('.');
	let subdomain = '';
	// 如果域名包含子域（如 www.example.com），parts 的长度会大于 2
	if (parts.length > 2) {
		subdomain = parts[0]; // 提取子域部分（如 www 或 cloud）
		console.log('子域是:', subdomain);
	} else {
		console.log('没有子域');
	}
	let url = '';
	if (!isProduction) {
		url = 'http://111.9.8.241:31215?date=';
	} else {
		if (subdomain == 'cloud') {
			url = 'https://cloud.lqzhcs.com.cn/financial/';
		} else {
			url = 'https://www.lqzhcs.com.cn/financial/';
		}
	}
	// let url = isProduction ? 'https://cloud.lqzhcs.com.cn/financial' : 'http://111.9.8.241:31215?date=';
	let tabName = 'financial';
	if (isElectron()) {
		return electronOpenUniqueTab(url, tabName);
	}
	url += Date.now();
	// 检查是否已经打开过该标签页
	// let existingTab: any = window.open('', tabName);
	// if (existingTab.location.href === 'about:blank' || existingTab.closed) {
	// 如果标签页没有打开，则打开一个新标签页
	// existingTab = window.open(url, tabName);
	// } else {
	// 如果已经存在先关闭再打开
	// existingTab.close();
	window.financialTab = window.open(url, tabName);
	// }
};

// 数字千分位
util.formatNumberToThousands = function (input: string | number) {
	// 将输入转换为数字
	const num = Number(input);

	// 检查转换是否成功
	if (isNaN(num)) {
		return '-';
	}

	// 处理负数情况
	const isNegative = num < 0;
	const absoluteNum = Math.abs(num);

	// 使用 toLocaleString 方法进行千分位格式化，保留两位小数
	const formattedNumber = absoluteNum.toLocaleString('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2, // 保持两位小数
	});

	// 返回带负号的格式化数字
	return isNegative ? `-${formattedNumber}` : formattedNumber;
};

// 千分位反转为数字
util.convertThousandsToNumber = function (input: any) {
	// 先去除输入中的逗号
	let str = input.replace(/,/g, '');
	// 将字符串转换为数字
	let num = Number(str);
	return num;
};

util.convertToPercentage2 = function (decimal: number) {
	// 乘以100并取整，添加百分号
	return `${Math.round(decimal * 100)}%`;
};

util.convertToPercentage = function (decimal: number | string, defaultValue = '-') {
	// 如果数字为负，先取其绝对值，然后添加负号（可选）
	const numberDecimal = Number(decimal);
	let formattedValue;

	// 处理负数情况
	if (numberDecimal < 0) {
		formattedValue = `-${(Math.abs(numberDecimal) * 100).toFixed(2)}%`;
	} else {
		formattedValue = `${(numberDecimal * 100).toFixed(2)}%`;
	}

	// 如果decimal不是有效的数字，则使用默认值
	if (isNaN(numberDecimal)) {
		return defaultValue;
	}

	return formattedValue;
};

util.convertToTenThousand = (num: string | number, unit: string = '', defaultValue: string = '-') => {
	// 尝试将输入值转换为数字
	const inputNumber = Number(num);

	// 如果转换成功且是数字，则继续处理
	if (!isNaN(inputNumber)) {
		// 判断是否为负数（可选处理）
		const isNegative = inputNumber < 0;
		const absoluteValue = Math.abs(inputNumber);

		// 转换为万元单位并保留两位小数（可按需调整）
		const tenThousand = (absoluteValue / 10000).toFixed(2);

		// 构建结果字符串（包含“万”单位）
		const tenThousandFormatted = util.formatNumberToThousands(tenThousand);
		const result = isNegative ? '-' + tenThousandFormatted : tenThousandFormatted;
		return result + unit; // 返回结果字符串
	} else {
		// 如果格式异常或无法转换，返回指定的默认值
		return util.formatNumberToThousands(defaultValue);
	}
};

util.getAreaByNsrsbh = function (nsrsbh: string) {
	if (!nsrsbh || nsrsbh.length !== 18) {
		return '';
	}
	// 根据18位纳税人识别号获取地区
	const codeAreaMap: Record<string, string> = {
		'11****': '北京',
		'35****': '福建',
		'53****': '云南',
		'12****': '天津',
		'36****': '江西',
		'54****': '西藏',
		'13****': '河北',
		'37****': '山东',
		'61****': '陕西',
		'14****': '山西',
		'41****': '河南',
		'62****': '甘肃',
		'15****': '内蒙古',
		'42****': '湖北',
		'63****': '青海',
		'21****': '辽宁',
		'43****': '湖南',
		'64****': '宁夏',
		'22****': '吉林',
		'44****': '广东',
		'65****': '新疆',
		'23****': '黑龙江',
		'45****': '广西',
		'2102**': '大连',
		'31****': '上海',
		'46****': '海南',
		'3302**': '宁波',
		'32****': '江苏',
		'50****': '重庆',
		'3502**': '厦门',
		'33****': '浙江',
		'51****': '四川',
		'3702**': '青岛',
		'34****': '安徽',
		'52****': '贵州',
		'4403**': '深圳',
	};

	// 获取第3-8位字符串
	const nsrsbhSubstr = nsrsbh.substring(2, 8);
	let matchedArea = '';

	const specialCodeArr = ['3502', '3702', '2102', '4403', '3302'];
	const specialCode = nsrsbhSubstr.substring(0, 4);

	if (specialCodeArr.includes(specialCode)) {
		matchedArea = codeAreaMap[specialCode + '**'];
	} else {
		const normalCode = nsrsbhSubstr.substring(0, 2);
		matchedArea = codeAreaMap[normalCode + '****'];
	}
	return matchedArea || ''; // 如果没有匹配，返回 '未知地区'
};

// 百分比字符串转数值
util.fromPercentString = (percent: string): string => {
	if (percent) {
		return (parseFloat(percent.replace('%', '')) / 100).toString();
	} else {
		return percent;
	}
};

/**
 * 提取首字母，返回大写形式。如果是中文则转化成拼音再转化。
 * @param str 输入字符串
 * @returns 首字母大写形式
 */
util.getCamelChars = function (str: string): string {
	if (!str) return '';

	let result = '';

	for (const char of str) {
		// 检查是否是中文字符
		const isChinese = /[\u4e00-\u9fa5]/.test(char);

		if (isChinese) {
			// 将中文字符转换为拼音
			const pinyinArray = pinyin(char, { style: pinyin.STYLE_FIRST_LETTER });
			if (pinyinArray && pinyinArray.length > 0 && pinyinArray[0].length > 0) {
				result += pinyinArray[0][0].toUpperCase();
			}
		} else {
			// 非中文字符，直接返回大写形式
			result += char.toUpperCase();
		}
	}

	return result;
};

util.transChineseToPinyin = function (str: string): string {
	return pinyin(str, { toneType: 'none', separator: '' });
};

util.getETaxAppDownloadQrocde = function (area: string) {
	if (area) {
		const qrcodeContent = `https://dtax.${util.transChineseToPinyin(area)}.chinatax.gov.cn/app/appvcs/view/appvcs/home`;
		return QRCodeGenerator.generateWithIcon({
			text: qrcodeContent,
			width: 150,
			height: 150,
			colorDark: '#000000',
			colorLight: '#ffffff',
			icon: '/commons/js/fwtx/image/etax_app_logo.png',
			iconSize: 0.2,
			iconMargin: 2,
		});
	}
};

util.formatterNum = (num: any) => {
	if ([undefined, null, ''].includes(num)) return '-';
	return XEUtils.commafy(XEUtils.toNumber(num), { digits: 2 });
};

export default util;
